export const documentServices = [
    {
      name: "Pan Card",
      description: ''
    },
    {
      name: "Death Certificate",
      description: ''
    },
    {
      name: "Passport",
      description: ''
    },
    {
      name: "Voter Id Card",
      description: ''
    },
    {
      name: "Driving License",
      description: ''
    },
    {
      name: "Ration Card",
      description: ''
    },
    {
      name: "Birth Certificate",
      description: ''
    },
    {
      name: "Marriage Certificate",
      description: ''
    },
    {
      name: "Caste Certificate",
      description: ''
    },
    {
      name: "Income Certificate",
      description: ''
    },
    {
      name: "Domicile Certificate",
      description: ''
    },
    {
      name: "Senior Citizen Card",
      description: ''
    },
    {
      name: "Disability Certificate",
      description: ''
    },
    {
      name: "Character Certificate",
      description: ''
    },
    {
      name: "Health Insurance Card",
      description: ''
    },
    {
      name: "Education Certificates (10th, 12th, degree)",
      description: ''
    },
    {
      name: "Transfer Certificate",
      description: ''
    },
    {
      name: "Bonafide Certificate",
      description: ''
    },
    {
      name: "Scholarship Certificates",
      description: ''
    },
    {
      name: "Affidavits",
      description: ''
    },
    {
      name: "Notarized Documents",
      description: ''
    },
    {
      name: "Rent Agreement",
      description: ''
    },
    {
      name: "Pension Card",
      description: ''
    },
    {
      name: "Property Documents",
      description: ''
    },
    {
      name: "Vehicle Registration Certificate",
      description: ''
    },
    {
      name: "Income Tax Returns (ITR)",
      description: ''
    },
    {
      name: "Loan Documents",
      description: ''
    }
];

export const consultationServices = [
    {
      name: "General Legal Consultation",
      description: "One-on-one legal advice sessions"
    },
    {
      name: "Case-Specific Consultation",
      description: "Detailed analysis of specific legal cases"
    },
    {
      name: "Legal Strategy Sessions",
      description: "Strategic planning for legal matters"
    },
    {
      name: "Pre-Litigation Advice",
      description: "Guidance before filing legal proceedings"
    },
    {
      name: "Contract Review Consultation",
      description: "Review and analysis of legal contracts"
    },
    {
      name: "Business Legal Consultation",
      description: "Legal advice for business operations"
    },
    {
      name: "Family Law Consultation",
      description: "Legal advice on family matters"
    },
    {
      name: "Property Law Consultation",
      description: "Legal guidance on property matters"
    }
];

export const disputeResolutionServices = [
    {
      name: "Mediation Services",
      description: "Facilitated negotiation between parties"
    },
    {
      name: "Arbitration Services",
      description: "Binding dispute resolution process"
    },
    {
      name: "Conciliation Services",
      description: "Assisted settlement discussions"
    },
    {
      name: "Negotiation Support",
      description: "Support during settlement negotiations"
    },
    {
      name: "Dispute Assessment",
      description: "Evaluation of dispute resolution options"
    },
    {
      name: "Settlement Agreement Drafting",
      description: "Drafting legally binding settlement documents"
    }
];

export const notarialServices = [
    {
      name: "Document Notarization",
      description: "Official document authentication"
    },
    {
      name: "Affidavit Notarization",
      description: "Sworn statement authentication"
    },
    {
      name: "Power of Attorney Notarization",
      description: "Legal authority document authentication"
    },
    {
      name: "Deed Notarization",
      description: "Property deed authentication"
    },
    {
      name: "Contract Notarization",
      description: "Business contract authentication"
    },
    {
      name: "Will Notarization",
      description: "Last will and testament authentication"
    }
];

export const litigationSupportServices = [
    {
      name: "Legal Research",
      description: "Comprehensive legal research services"
    },
    {
      name: "Case Analysis",
      description: "Detailed analysis of legal cases"
    },
    {
      name: "Trial Preparation",
      description: "Preparation for court proceedings"
    },
    {
      name: "Document Preparation",
      description: "Preparation of legal documents"
    },
    {
      name: "Evidence Collection",
      description: "Assistance in evidence gathering"
    },
    {
      name: "Witness Preparation",
      description: "Preparation of witnesses for testimony"
    }
];

export const complianceServices = [
    {
      name: "Compliance Audits",
      description: "Comprehensive compliance reviews"
    },
    {
      name: "Regulatory Filings",
      description: "Assistance with government filings"
    },
    {
      name: "Policy Development",
      description: "Development of compliance policies"
    },
    {
      name: "Training Programs",
      description: "Compliance training for organizations"
    },
    {
      name: "Risk Assessment",
      description: "Evaluation of compliance risks"
    },
    {
      name: "Monitoring Services",
      description: "Ongoing compliance monitoring"
    }
];

export const legalRepresentationServices = [
    {
      name: "Court Representation",
      description: "Representation in court proceedings"
    },
    {
      name: "Tribunal Representation",
      description: "Representation before tribunals"
    },
    {
      name: "Administrative Hearings",
      description: "Representation in administrative proceedings"
    },
    {
      name: "Appellate Representation",
      description: "Representation in appeals"
    },
    {
      name: "Alternative Dispute Resolution",
      description: "Representation in ADR processes"
    }
];

export const intellectualPropertyServices = [
    {
      name: "Trademark Registration",
      description: "Trademark application and registration"
    },
    {
      name: "Patent Drafting",
      description: "Patent application drafting"
    },
    {
      name: "Patent Filing",
      description: "Patent application filing"
    },
    {
      name: "Copyright Registration",
      description: "Copyright protection services"
    },
    {
      name: "IP Infringement Analysis",
      description: "Analysis of IP infringement cases"
    },
    {
      name: "IP Licensing",
      description: "Intellectual property licensing"
    }
];

export const familyLawServices = [
    {
      name: "Divorce Proceedings",
      description: "Legal assistance in divorce cases"
    },
    {
      name: "Child Custody",
      description: "Child custody and visitation matters"
    },
    {
      name: "Child Support",
      description: "Child support calculation and enforcement"
    },
    {
      name: "Adoption Services",
      description: "Legal assistance in adoption processes"
    },
    {
      name: "Marriage Registration",
      description: "Legal marriage registration services"
    },
    {
      name: "Domestic Violence",
      description: "Protection orders and domestic violence cases"
    }
];

export const realEstateServices = [
    {
      name: "Property Title Search",
      description: "Comprehensive property title verification"
    },
    {
      name: "Lease Agreement Drafting",
      description: "Drafting of lease agreements"
    },
    {
      name: "Property Transaction Support",
      description: "Support in property buying/selling"
    },
    {
      name: "Property Registration",
      description: "Property registration assistance"
    },
    {
      name: "Land Dispute Resolution",
      description: "Resolution of land-related disputes"
    },
    {
      name: "Property Tax Matters",
      description: "Assistance with property tax issues"
    }
];

export const corporateServices = [
    {
      name: "Business Formation",
      description: "Company incorporation and registration"
    },
    {
      name: "Contract Negotiation",
      description: "Business contract negotiations"
    },
    {
      name: "Corporate Governance",
      description: "Corporate governance advisory"
    },
    {
      name: "Mergers and Acquisitions",
      description: "M&A legal support"
    },
    {
      name: "Corporate Compliance",
      description: "Corporate law compliance"
    },
    {
      name: "Board Advisory",
      description: "Legal advice to board of directors"
    }
];

export const employmentServices = [
    {
      name: "Employment Contract Drafting",
      description: "Drafting employment agreements"
    },
    {
      name: "Workplace Dispute Resolution",
      description: "Resolution of workplace conflicts"
    },
    {
      name: "Labor Law Compliance",
      description: "Employment law compliance"
    },
    {
      name: "Employee Handbook",
      description: "Drafting employee handbooks"
    },
    {
      name: "Termination Matters",
      description: "Legal assistance in termination cases"
    },
    {
      name: "Workplace Investigations",
      description: "Internal workplace investigations"
    }
];

export const cyberLawServices = [
    {
      name: "Data Privacy Compliance",
      description: "GDPR and data protection compliance"
    },
    {
      name: "Cybersecurity Legal Advice",
      description: "Legal guidance on cybersecurity"
    },
    {
      name: "Cybercrime Prevention",
      description: "Prevention of cybercrimes"
    },
    {
      name: "Digital Rights Management",
      description: "Protection of digital rights"
    },
    {
      name: "E-commerce Legal Support",
      description: "Legal support for online businesses"
    },
    {
      name: "Social Media Law",
      description: "Legal guidance on social media issues"
    }
];

export const trainingServices = [
    {
      name: "Legal Education Programs",
      description: "Comprehensive legal education"
    },
    {
      name: "Legal Training Sessions",
      description: "Specialized legal training"
    },
    {
      name: "Workshop for Professionals",
      description: "Professional development workshops"
    },
    {
      name: "Compliance Training",
      description: "Regulatory compliance training"
    },
    {
      name: "Contract Law Training",
      description: "Training on contract law"
    },
    {
      name: "Corporate Law Training",
      description: "Training on corporate law"
    }
];

export const customizedServices = [
    {
      name: "Tailored Legal Solutions",
      description: "Custom legal solutions for specific needs"
    },
    {
      name: "Project-Based Legal Support",
      description: "Legal support for specific projects"
    },
    {
      name: "Legal Process Outsourcing",
      description: "Outsourced legal services"
    },
    {
      name: "Legal Technology Solutions",
      description: "Technology-enabled legal services"
    },
    {
      name: "Legal Risk Management",
      description: "Comprehensive legal risk assessment"
    },
    {
      name: "Legal Strategy Consulting",
      description: "Strategic legal consulting services"
    }
];
  